"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortcutOperationList = void 0;
const Enums_1 = require("../../PredefinedConfig/Common/Enums");
exports.shortcutOperationList = [
    Enums_1.MathOperation.Add,
    Enums_1.MathOperation.Subtract,
    Enums_1.MathOperation.Multiply,
    Enums_1.MathOperation.Divide,
];
